module.exports = __webpack_public_path__ + "img/0Q3A5801_L_Black_MockedUp.a4fb000d.jpg";